import db from "@/plugins/dexie"
import moment from "moment-timezone";
import dadosTabelas from "./local/tabelas"
import apirecebimentoweb from '@/services/api-recebimentoweb';
//import { USER_STORAGE  } from '@/constants/STORAGE'

import $_enviaAbastecimento from "./local/enviaAbastecimento";
import { $_deletaAbastecimento } from "./local/enviaAbastecimento";
import $_enviaSecagem from "./local/enviaSecagem";
import $_enviaApontamento from "./local/enviaApontamento";
import $_enviaAmostra from "./local/enviaAmostra";
import $_enviaOrdem from "./local/enviaOrdem";
import $_enviaOrdemItem from "./local/enviaOrdemItem";
import $_enviaOrdemUnidade from "./local/enviaOrdemUnidade";
import { $_deletaOrdemUnidade } from "./local/enviaOrdemUnidade";

import store from '@/store/index';
import geraData from "./geradata";
import $_enviaImagem from "./local/enviaImagem";
import $_enviaFormulario from "./local/enviaFormulario";
import $_limpaFormularioLocal from "./local/limpaFormularioLocal";


/* function getSessionStorage(key, defaultValue) {
    return sessionStorage.getItem(key) ?? defaultValue;
} */

export default async function $_atualizaLocal() {
    console.log('=>>>');
    store.dispatch('atualizalocal/updateProcessados', 0);
    store.dispatch('atualizalocal/updateTotal', 0);
    const info = dadosTabelas();
    const cache = store.getters['cache/arraydata'];
    let arrayDataAtualizacao;
    if (!cache.length) {
    arrayDataAtualizacao = await Promise.all(Object.entries(info).map(async ([ nome, dados ]) => {

        const dataatt = await db[nome].orderBy(dados.campoatt).filter(item => item[dados.campoatt] !== null).last();
        const dataattFinal = dataatt?.[dados.campoatt] || '01/01/1997 13:00:00';
        //console.log('DATA ATT SENDO ENVIADA', nome, dataattFinal, moment.utc(dataattFinal).format('YYYY-MM-DD HH:mm:ss.SSS'))
        console.log(dados.nomeapi || nome, 'data', dataattFinal);
        // `parametros`: recorte opcional (checklist).
        if (!dataattFinal) {
            return {
                tabela: dados.nomeapi || nome,
                tabelaApp: nome,
                data: moment.utc('01-01-1997 13:00:00', 'DD-MM-YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss'),
                ...(dados.parametros ? { parametros: dados.parametros } : {})
            };
        } else {
            return {
                tabela: dados.nomeapi || nome,
                tabelaApp: nome,
                data: moment.utc(dataattFinal).format('YYYY-MM-DD HH:mm:ss.SSS'),
                ...(dados.parametros ? { parametros: dados.parametros } : {})
            };
        }
    }));
    store.commit('cache/SET_CACHE_ARRAYDATA', arrayDataAtualizacao);
  } else {
    arrayDataAtualizacao = store.getters['cache/arraydata'];
    arrayDataAtualizacao.forEach((ar) => console.log('Tabela: ', ar.tabela, 'Data: ', ar.data))
  }
    if (arrayDataAtualizacao.every(item => item.data === "1997-01-01 13:00:00")) {
      store.dispatch('atualizalocal/primeiroUpdate', true);
      store.dispatch('cache/primeiroUpdate', true);
    }
    const retorno = await apirecebimentoweb.post(`all/itemsaatualizar`, arrayDataAtualizacao);
    store.dispatch('atualizalocal/primeiroUpdate', false);
    console.log('<<<=');
    $_geraTotal(retorno.data);
    retorno.data.forEach((item) => {
        //console.log('tabela');
        $_geraLog(item);
        $_manipulaTabela(item, info);
        // $_manipulaTabelaComDelay(item, info);
    })
    // console.time('$$$');
    // await $_manipulaTabela(retorno.data[0], info);
    // console.timeEnd('$$$');
}

// eslint-disable-next-line no-unused-vars
async function $_geraLog({ data, tabela }) {
    console.log('%cTabela: ' + tabela, 'font-weight: bold; border-top: 1px solid #fff; padding-top: 3px')
    console.log('%c' + data.length + '%c itens para criação ou atualização', 'color: ' +
        (data.length > 0) ? '#f65' : '#5cc', 'color: #fff');
}

// eslint-disable-next-line no-unused-vars
async function $_manipulaTabela({ data, tabela }, info) {
    let idnuvem = await db[tabela].toArray();
    let idLocal = idnuvem.reduce((ids, item) => {
      const key = item[`${info[tabela].prefixo}idnuvem`];
      const value = item.id; 
      ids[key] = value;
      return ids;
    }, {});

    idnuvem = idnuvem.map((item) => item[`${info[tabela].prefixo}idnuvem`]);

    await $_deletaLocal(idnuvem, tabela, info);

    if (!idnuvem) { idnuvem = []; }
    
    const novosItens = [];
    const modificacoes = [];
    
    const totalItems = data.length;

    let processedItems = 0;
    const progressThreshold = Math.floor(totalItems * 0.01) || 1;

    let possuiUpdates = false;
    let possuiCreates = false;

    data.forEach((item) => {
        const itemFormatado = info[tabela].model(item);
        if (idnuvem.includes(item.id)) {
            if (!possuiUpdates) {
                possuiUpdates = true;
                store.dispatch('atualizalocal/addAAtualizar', 1);
            }
            modificacoes.push({
                key: idLocal[item.id],
                changes: itemFormatado
            });
        } else {
            if (!possuiCreates) {
                possuiCreates = true;
                store.dispatch('atualizalocal/addAAdicionar', 1);
            }
            novosItens.push(itemFormatado);
        }
        
        processedItems++;

        if (processedItems >= progressThreshold) {
            store.dispatch('atualizalocal/addProcessados', processedItems);
            processedItems = 0;
        }
    });

    if (processedItems > 0) {
        store.dispatch('atualizalocal/addProcessados', processedItems);
    }

    if (modificacoes.length > 0) {
        try {
          if(tabela === 'secagem') {
            modificacoes.map((mod) => {
              db.operacao.where({opeidnuvem: mod.changes.secidnuvem}).first().then((ope) => {
                db.operacao.update(ope.id, {
                  opesecagem: mod.changes.secstatus,
                  opedatainicio: geraData(mod.changes.secdatainicio)
                })
              })
            })
          }
            await db[tabela].bulkUpdate(modificacoes);

            const [dataalteracao] = Object.keys(modificacoes[0].changes).filter((item) => item.includes('dataalteracao'));
            const ultimaDataAlteracao = modificacoes
              .map((obj) => obj.changes)
              .sort((a, b) => new Date(b[dataalteracao]) - new Date(a[dataalteracao]))
              .shift()[dataalteracao]
            store.dispatch('cache/atualizaData', { data:  moment.utc(ultimaDataAlteracao).format('YYYY-MM-DD HH:mm:ss.SSS'), tabela });
      
            store.dispatch('atualizalocal/addEstaAtualizado', tabela);  
            if (
              [
                'ordemcarregamento',
                'ordemcarregamentoitem',
                'ordemcarregamentounidade',
                'apontamentoproducao',
              ].includes(tabela)
            ) {
              store.dispatch('cache/reloadCache', tabela );
            } else {
              store.dispatch('cache/esvaziarCache', { tabela });
            }
            // O DUN mantém um cache próprio (subconjunto de aberturalote com
            // ablcodigodun); ao atualizar aberturalote, invalida também o do DUN.
            if (tabela === 'aberturalote') {
              store.dispatch('cache/esvaziarCache', { tabela: 'aberturalotedun' });
              store.dispatch('cache/esvaziarCache', { tabela: 'aberturalote' });
            }
        } catch (err) {
            console.error("Bulk Update Error:", err);
            store.dispatch('atualizalocal/addEstaAtualizado', { tabela, erro: err.message });
        }
    }
    
    if (novosItens.length > 0) {
        try {
          if (tabela === 'secagem') {
            // eslint-disable-next-line no-unused-vars
            for (const [index,value] of Object.entries(novosItens)) {
              console.log('value', value)
               await db.operacao.add({
                  opeidnuvem: value.secidnuvem,
                  opedatainicio: value.secdatainicio,
                  opeidsecador: value.secidsecador,
                  opesecagem: value.secstatus,
                  opeidusuario: `${value.secidusuario}`,
                  opepeso: parseFloat(value.secpesoentrada),
                  opetemperaturaar: value.sectemperaturaar,
                  opeumidadear: value.secumidadear,
                  opeumidade: value.secumidade,
                  opetipo: value.sectipooperacao,
                })
            }
          }
          if(tabela === 'amostra') {
            novosItens.sort((a, b) => new Date(a.amodataamostra) - new Date(b.amodataamostra));
          }
            await db[tabela].bulkAdd(novosItens, { allKeys: true }).catch((err) => {
              //store.dispatch('debug/addDebug', err);
              console.log('erro ao adicionar novos itens', err);
            });
          
            if ([
              'ordemcarregamento',
              'ordemcarregamentoitem',
              'ordemcarregamentounidade'
            ].includes(tabela)) {
              store.dispatch('cache/reloadCache', tabela);
            } 
            if ([
              'turno',
              'aberturalote',
              'fabrica',
              'apontamentoproducao',
            ].includes(tabela)) {
              store.dispatch('cache/pushCache', {tabela, novosItens});
            }
            // Novos lotes podem incluir lotes com DUN; invalida o cache do DUN
            // para que ele seja refiltrado no próximo carregamento.
            if (tabela === 'aberturalote') {
              store.dispatch('cache/esvaziarCache', { tabela: 'aberturalotedun' });
            }
            if (tabela === 'localarmazenamento') store.dispatch('cache/esvaziarCache', { tabela })
            
            const primeiroUpdate = store.getters['cache/primeiroUpdate'];
            console.log('primeiro UPDATE', primeiroUpdate);
            if (!primeiroUpdate) {              
              const [dataalteracao] = Object.keys(novosItens[0]).filter((item) => item.includes('dataalteracao'));
              const ultimaDataAlteracao = novosItens
                .sort((a, b) => new Date(b[dataalteracao]) - new Date(a[dataalteracao]))
                .shift()[dataalteracao]

              store.dispatch('cache/atualizaData', { data: moment.utc(ultimaDataAlteracao).format('YYYY-MM-DD HH:mm:ss.SSS'), tabela });
            }
            //store.dispatch('debug/addDebug', novosItens);
            store.dispatch('atualizalocal/addEstaAdicionado', tabela);
        } catch (err) {
            console.error("Bulk Add Error:", err);
            store.dispatch('atualizalocal/addEstaAdicionado', { tabela, erro: err.message });
        }
    }
}


// ⚠️ Usar somente para testes
// eslint-disable-next-line no-unused-vars
async function $_manipulaTabelaComDelay({ data, tabela }, info) {
    console.log(`⚠️ Atualizando em modo TESTE`);
    
    let idnuvem = await db[tabela].toArray();
    idnuvem = idnuvem.map((item) => item[`${info[tabela].prefixo}idnuvem`]);

    await $_deletaLocal(idnuvem, tabela);

    if (!idnuvem) { idnuvem = []; }

    const novosItens = [];
    const modificacoes = [];

    const totalItems = data.length;
    let processedItems = 0;
    const progressThreshold = Math.floor(totalItems * 0.01);

    let possuiUpdates = false;
    let possuiCreates = false;

    for (let i = 0; i < totalItems; i++) {
        const item = data[i];
        const itemFormatado = info[tabela].model(item);

        if (idnuvem.includes(item.id)) {
            if (!possuiUpdates) {
                possuiUpdates = true;
                store.dispatch('atualizalocal/addAAtualizar', 1);
            }
            modificacoes.push({
                id: item.id,
                updates: itemFormatado
            });
        } else {
            if (!possuiCreates) {
                possuiCreates = true;
                store.dispatch('atualizalocal/addAAdicionar', 1);
            }
            novosItens.push(itemFormatado);
        }

        processedItems++;

        if (processedItems >= progressThreshold) {
            store.dispatch('atualizalocal/addProcessados', progressThreshold);
            processedItems = 0;
        }

        await delay(1);
    }

    if (modificacoes.length > 0) {
        try {
            await db[tabela].bulkUpdate(modificacoes);
            store.dispatch('atualizalocal/addEstaAtualizado', tabela);
        } catch (err) {
            console.error("Bulk Update Error:", err);
            store.dispatch('atualizalocal/addEstaAtualizado', { tabela, erro: err.message });
        }
    }

    if (novosItens.length > 0) {
        try {
            await db[tabela].bulkAdd(novosItens, { allKeys: true });
            store.dispatch('atualizalocal/addEstaAdicionado', tabela);
        } catch (err) {
            console.error("Bulk Add Error:", err);
            store.dispatch('atualizalocal/addEstaAdicionado', { tabela, erro: err.message });
        }
    }
}





async function $_geraTotal(data) {
    let total = 0
    for (const tabela of data) {
        total += tabela.data.length;
    }
    store.dispatch('atualizalocal/updateTotal', total);
}

// eslint-disable-next-line no-unused-vars
async function $_deletaLocal(idnuvemlocal, tabela, info) {
     // Mesmo recorte do delta.
     const params = info[tabela]?.parametros;
     let { data } = await apirecebimentoweb.get(`${tabela}/idnuvem`, params ? { params } : undefined)
     data = new Set(data.map((item) => item.id));
     const deleteIds = idnuvemlocal.filter(idnuvem => !data.has(idnuvem) && idnuvem !== 'null');

      if (deleteIds.length > 0) {
       console.log(`Deletar na ${tabela}:`, deleteIds, idnuvemlocal);
       const chunkSize = 500;

        for (let i = 0; i < deleteIds.length; i += chunkSize) {
          const chunk = deleteIds.slice(i, i + chunkSize);

          await db.transaction('rw', db[tabela], async () => {
            await db[tabela]
              .where(`${info[tabela].prefixo}idnuvem`)
              .anyOf(chunk)
              .delete();
          });
        }
        if (['ordemcarregamentounidade', 'apontamentoproducao'].includes(tabela)) {
          store.dispatch('cache/reloadCache', tabela);
          return;
        }
        store.dispatch('cache/esvaziarCache', { tabela, att: info[tabela].campoatt });
        // Exclusões em aberturalote também invalidam o cache próprio do DUN.
        if (tabela === 'aberturalote') {
          store.dispatch('cache/esvaziarCache', { tabela: 'aberturalotedun' });
        }
      }

      if (deleteIds.length > 0 && ['amostra', 'secagem'].includes(tabela)) {
        deleteIds.forEach((itemlocal) => {
             if(tabela === 'amostra') {
              db[tabela].where({ [`${info[tabela].prefixo}idnuvem`]: itemlocal }).first().then((item) => {
                db[tabela].where({ [`${info[tabela].prefixo}idnuvem`]: itemlocal }).delete();
                db[tabela].where({amodataoperacao: item.amodataoperacao}).last().then((upd) => {
                  db[tabela].update(upd.id, {amodatastatus: null})
                });
              })
           } else if(tabela === 'secagem') {
             db.operacao.where({opeidnuvem: itemlocal }).delete();
             db[tabela].where({ [`${info[tabela].prefixo}idnuvem`]: itemlocal }).delete();
           }
        })
      }
}

// DELAY PARA TESTES DE PERFORMANCE
function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}


/**
 * LOCK (Trava de processo)
 *
 * Este lock garante que apenas UM processo de envio seja executado
 * por vez no navegador, mesmo em cenários como:
 * - múltiplas abas abertas
 * - múltiplos cliques no botão de sincronização
 * - execuções automáticas simultâneas (timer, onLine, focus, etc)
 *
 * O lock é persistido no IndexedDB (Dexie), portanto:
 * - sobrevive a reload da página
 * - impede execuções paralelas entre abas
 *
 * Para evitar lock "fantasma" (de uma aba fechada/recarregada no meio de
 * um sync, antes do liberarLock() rodar), o detentor mantém um HEARTBEAT:
 * enquanto sincroniza, renova `lock.data` a cada HEARTBEAT_MS. Um lock só
 * é considerado morto se ficar sem heartbeat por mais de STALE_THRESHOLD.
 * Além disso, a aba detentora libera o lock no fechamento (pagehide), e o
 * disparo inicial pode aguardar o lock liberar (aguardarLock) em vez de
 * ser descartado silenciosamente.
 */


const HEARTBEAT_MS = 5 * 1000;       // renova o lock a cada 5s enquanto sincroniza
const STALE_THRESHOLD = 15 * 1000;   // lock sem heartbeat há > 15s é considerado morto
const TAB_ID = `${Date.now()}-${Math.random().toString(36).slice(2)}`;

let heartbeatId = null;
let listenerRegistrado = false;
let souDono = false; // esta aba detém o lock atualmente?

function iniciarHeartbeat() {
  pararHeartbeat();
  heartbeatId = setInterval(async () => {
    try {
      const lock = await db.processo.get('envio');
      // Só renova enquanto esta aba ainda for a dona do lock
      if (lock?.owner === TAB_ID) {
        await db.processo.update('envio', { data: Date.now() });
      } else {
        pararHeartbeat();
      }
    } catch (err) {
      console.error('Erro no heartbeat do lock:', err);
    }
  }, HEARTBEAT_MS);
}

function pararHeartbeat() {
  if (heartbeatId) {
    clearInterval(heartbeatId);
    heartbeatId = null;
  }
}

// Libera o lock se a aba for fechada/recarregada/navegada no meio de um sync,
// evitando lock "fantasma". Registrado uma única vez por aba.
function registrarLiberacaoNoFechamento() {
  if (listenerRegistrado) return;
  listenerRegistrado = true;

  // pagehide cobre fechamento/navegação/unload (e bfcache) de forma mais
  // confiável que unload. Se o navegador for morto sem disparar o evento,
  // o backstop é o heartbeat + STALE_THRESHOLD.
  window.addEventListener('pagehide', () => {
    if (souDono) {
      souDono = false;
      db.processo.delete('envio').catch(() => {});
    }
  });
}

async function adquirirLock() {
  return db.transaction('rw', db.processo, async () => {
    const lock = await db.processo.get('envio');

    if (lock?.ativo) {
      const diff = Date.now() - new Date(lock.data).getTime();

      // Lock ainda vivo (heartbeat recente) → outro sync em andamento
      if (diff < STALE_THRESHOLD) {
        console.log('LOCK ATIVO');
        return false;
      }
      // Lock sem heartbeat (detentor morto) → continua e recria
    }

    await db.processo.put({
      key: 'envio',
      ativo: true,
      data: Date.now(),
      owner: TAB_ID
    });

    souDono = true;
    return true;
  });
}

async function liberarLock() {
  pararHeartbeat();
  souDono = false;
  await db.processo.delete('envio');
}

export async function SetupEnvioLocal({ silent = false, aguardarLock = false } = {}) {
  // TTL do checklist roda mesmo offline.
  await $_limpaFormularioLocal().catch((err) => {
    console.error('[CHECKLIST] falha no TTL local', err);
  });

  if (!navigator.onLine) return false;

  registrarLiberacaoNoFechamento();

  let lockObtido = await adquirirLock();

  // Chamada sem espera (intervalo/online/troca de menu): se o lock estiver
  // ocupado, desiste em silêncio sem ligar o indicador de sincronização.
  if (!lockObtido && !aguardarLock) return false;

  // A partir daqui esta chamada está comprometida (vai rodar ou aguardar),
  // então liga o indicador de "Sincronizando" para dar feedback imediato
  // (inclusive durante a espera do lock em conexões lentas).
  store.dispatch('atualizalocal/syncStart');
  try {
    // Disparo inicial (ex.: home): se o lock estiver ocupado, aguarda liberar
    // em vez de descartar silenciosamente o GET. Como TEMPO_MAX_ESPERA é maior
    // que STALE_THRESHOLD, um lock fantasma é recuperado dentro do loop; se ao
    // fim ainda estiver vivo, é outro sync legítimo em andamento e não forçamos.
    if (!lockObtido && aguardarLock) {
      const TEMPO_MAX_ESPERA = 20 * 1000;
      const INTERVALO_POLL = 500;
      const inicio = Date.now();

      while (!lockObtido && (Date.now() - inicio) < TEMPO_MAX_ESPERA) {
        await delay(INTERVALO_POLL);
        lockObtido = await adquirirLock();
      }
    }

    if (!lockObtido) return false;

    iniciarHeartbeat();
    try {
      await $_atualizaLocal(silent);
      await $_enviaApontamento();
      await $_enviaAbastecimento();
      await $_deletaAbastecimento();
      await $_enviaSecagem();
      await $_enviaAmostra();
      // O.C. por último: a API ignora alteração de unidade de O.C. finalizada.
      await $_enviaOrdemUnidade();
      await $_deletaOrdemUnidade();
      await $_enviaOrdemItem();
      await $_enviaOrdem();
      await $_enviaImagem();
      await $_enviaFormulario();
    } finally {
      await liberarLock();
    }
    return true;
  } finally {
    store.dispatch('atualizalocal/syncEnd');
  }
}



